var app = angular.module('leonardo');

var PageHomeDirective = function(ConfigThemeService) {
  return {
    restrict: 'C',
    scope: {
      pageColor: '@'
    },
    link: function (scope, element) {

      scope.setColor = function() {
        var color = scope.pageColor ? ConfigThemeService.getColor(scope.pageColor) : ConfigThemeService.getColor('secondaryColor', 0.3);
        element.css('background-color', color);
      };

      scope.setColor();


      scope.$on('config-theme:updated', function () {
        scope.setColor();
      });
    }
  };
};

app.directive('pageHome', ['ConfigThemeService', PageHomeDirective]);
